<template>
  <div class="d-flex gap-2" :class="column ? 'flex-column' : 'align-center'">
    <v-switch
      :input-value="value.inHouse"
      dense
      inset
      hide-details
      class="mt-0"
      label="In House Only"
      :loading="filterLoading"
      @change="updateFilters('inHouse', Boolean($event))"
    />
    <b v-if="dateLabel" class="text--secondary">{{ dateLabel }}</b>
    <div v-if="defaultStartDate">{{ defaultStartDate | formatDate }} - {{ endDate | formatDate }}</div>
    <div v-else class="d-flex align-center gap-2">
      <v-menu v-model="dateStartMenu" :close-on-content-click="false" left>
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            outlined
            v-on="on"
          >
            <v-icon small>mdi-calendar</v-icon> From: {{ value.dateStart | formatDate }}
          </v-btn>
        </template>
        <v-date-picker :value="value.dateStart" @input="updateDate('dateStart', $event)" />
      </v-menu>
      <v-menu v-model="dateEndMenu" :close-on-content-click="false" left>
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            outlined
            v-on="on"
          >
            <v-icon small>mdi-calendar</v-icon> To: {{ endDate | formatDate }}
          </v-btn>
        </template>
        <v-date-picker :value="value.dateEnd" @input="updateDate('dateEnd', $event)" />
      </v-menu>
    </div>
    <v-select
      :value="value.propertyType"
      outlined
      label="Select Property Type"
      dense
      hide-details
      :items="propertyTypes"
      :loading="loading"
      :style="selectStyle"
      clearable
      @change="updateFilters('propertyType', $event || null)"
    />
    <SavedSetSelect
      :value="value.savedSet"
      :source="source"
      :style="selectStyle"
      @input="updateFilters('savedSet', $event)"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

import { Nullable } from '@/utils/types';
import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';
import { IDashboardCardFilters } from '@/bundles/Dashboard/interfaces';
import { AdminStoreDataListEnum } from '@/store/modules/admin/types/AdminStoreDataListEnum';

import SavedSetSelect from '@/bundles/SavedSets/components/SavedSetSelect.vue';

interface IDashboardCardFiltersFieldsData {
  dateStartMenu: boolean;
  dateEndMenu: boolean;
}

export default Vue.extend({
  name: 'DashboardCardFiltersFields',

  components: { SavedSetSelect },

  props: {
    value: {
      type: Object as PropType<IDashboardCardFilters>,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    column: Boolean,
    dateLabel: {
      type: String,
      default: '',
    },
    defaultStartDate: {
      type: String,
      default: '',
    },
    defaultEndDate: {
      type: String,
      default: '',
    },
    loading: Boolean,
    filterLoading: Boolean,
  },

  data: (): IDashboardCardFiltersFieldsData => ({
    dateStartMenu: false,
    dateEndMenu: false,
  }),

  computed: {
    ...mapGetters('Admin', ['getListByCategory']),
    propertyTypes (): PropertyTypeEnum[] {
      return this.getListByCategory(AdminStoreDataListEnum.property_types).items;
    },
    endDate (): string {
      return this.defaultEndDate || this.value.dateEnd;
    },
    selectStyle (): Nullable<string> {
      return this.column ? null : 'max-width: 200px';
    },
  },

  methods: {
    updateFilters (field: keyof IDashboardCardFilters, fieldValue: unknown) {
      this.$emit('input', { ...this.value, [field]: fieldValue });
    },
    updateDate (field: 'dateStart' | 'dateEnd', fieldValue: string) {
      this.dateStartMenu = false;
      this.dateEndMenu = false;
      this.updateFilters(field, fieldValue);
    },
  },
});
</script>
